<template>
  <div class="toggle-wrap" :class="size">
    <span v-if="leftLabel != ''" class="toggle-left-label">{{leftLabel}}</span>

    <Toggle
      v-model="isToggled"
      class="dtt-toggle"
      :class="[size, { 'dtt-toggle-disabled' : disabled === true}]"
      :id="id"
      :name="name"
      :true-value="trueValue"
      :false-value="falseValue"
      :disabled="disabled"
      :required="required"
      @change="change"
    />

    <span v-if="rightLabel != ''" class="toggle-right-label">{{rightLabel}}</span>
  </div>
</template>


<script>
import Toggle from '@vueform/toggle/dist/toggle.vue2.js'

export default {
  components: { Toggle },

  model: {
    prop: "modelValue",
    event: "change"
  },

  props:{
    modelValue: {
      type: [Array,Boolean,String],
      default: null,
      required: false
    },

    id: {
      type: String,
      default: null,
      required: false,
    },

    name: {
      type: String,
      default: null,
      required: false,
    },

    value: {
      type: String,
      default: null,
      required: false,
    },

    size: {
      type: String,
      default: 'md',
      required: false,
    },

    trueValue: {
      type: [String,Boolean],
      default: true,
      required: false,
    },

    falseValue: {
      type: [String,Boolean],
      default: false,
      required: false,
    },

    leftLabel: {
      type: String,
      default: '',
      required: false,
    },

    rightLabel: {
      type: String,
      default: '',
      required: false,
    },

    disabled: {
      type: Boolean,
      default: false,
      required: false,   
    },

    required: {
      type: Boolean,
      default: false,
      required: false, 
    }
  },
  
  computed: {
    isToggled: {
      get: function(){
        return this.modelValue ;
      },
      set: function(val){
        this.modelValue  === val;
      }  
    }
  },

  methods:{
    change(val){
      this.$emit("change", val);
    }
  }
};
</script>


<style src="@vueform/toggle/themes/default.css"></style>

<style lang="scss">
  .toggle-wrap{
    display: flex;
    align-items: center;
  }

  //Styling for Default Toggle
  .dtt-toggle {
    --toggle-border: 0.125rem;
    --toggle-duration: 150ms;
    --toggle-bg-on: var(--primary);
    --toggle-bg-off: var(--gray-500);
    --toggle-bg-on-disabled: #d1d5db;
    --toggle-bg-off-disabled: #e5e7eb;
    --toggle-border-on: var(--primary);
    --toggle-border-off: var(--gray-500);
    --toggle-border-on-disabled: #d1d5db;
    --toggle-border-off-disabled: #e5e7eb;
    --toggle-text-on: #ffffff;
    --toggle-text-off: #ffffff;
    --toggle-text-on-disabled: #9ca3af;
    --toggle-text-off-disabled: #9ca3af;
    --toggle-handle-enabled: #ffffff;
    --toggle-handle-disabled: #f3f4f6;
    box-shadow:none !important;
  }

  .toggle-handle{
    box-shadow: 0px 3px 6px #00000029;
  }

  .toggle-label{
    text-transform: uppercase;
    font-size: 11px!important;
  }

  .toggle-left-label{
    margin-right: 12px;
  }
  

  .toggle-right-label{
    margin-left: 12px;
  }
  
  //Styling for Small Toggle
  .sm{
    --toggle-width: 30px;
    --toggle-height: 16px;

    .toggle-handle{
      width: 16px;
      height: 16px;
    }

    .toggle-label{
      font-size: 9px!important;
    }

    .toggle-left-label, .toggle-right-label{
      font-size: 13px;
    }
  }


  //Styling for Medium Toggle
  .md{
    --toggle-width: 36px;
    --toggle-height: 20px;

    .toggle-handle{
      width: 20px;
      height: 20px;
    }

    .toggle-label{
      font-size: 9px!important;
    }
  }


  //Styling for Large Toggle
  .lg{
    --toggle-width: 46px;
    --toggle-height: 24px;

    .toggle-handle{
      width: 24px;
      height: 24px;
    }

    .toggle-label{
      font-size: 13px!important;
    }

    .toggle-left-label, .toggle-right-label{
      font-size: 18px;
    }
  }

  //Styling for Disabled Toggle
  .dtt-toggle-disabled {
    .toggle-handle{
      box-shadow: none;
    }
  }
</style>